import { Prop, Component } from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import ReportFilters from './report-filters';
import _ from 'lodash';
import BaseMetricsMixin from '@/views/reports/pickers/base/base-metrics-mixin';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';

/*
*  Base class for report tables
* */
@Component
export default class ReportBase extends mixins(UrlMixin,  ReportFilters, BaseMetricsMixin, ReportMetricsMixin) {
  @Prop(Boolean) 
  subReport!: boolean;

  @Prop({default: true}) 
  resizable!: boolean;

  @Prop({default: {}})
  treeView!: any[];

  @Prop({default: 0}) 
  treeLevel!: number;

  @Prop() 
  treeParent!: any;

  @Prop(String) 
  type!: string;

  @Prop(String) 
  filterTables!: string;

  @Prop(String) 
  filterValues!: string;

  @Prop()
  previousFilter!: Bemob.ReportQueryDrill[];

  tree: any = {};

  get grouping() {
    const { dimensions } = this.$store.state.reportColumns

    return _.get(dimensions[this.type || this.basicType], 'mainColumn', null);
  }

  get rootGrouping() {
    const { dimensions } = this.$store.state.reportColumns

    return _.get(dimensions[this.basicType], 'mainColumn', null);
  }

  get selectedMetrics() {
    const { columns } = this.$store.getters.reportParams

    return this.append_metrics
      .map(({ value }) => (value))
      .concat(columns);
  }

  get computedFooter() {
    let appendMetricsParams: any = {};
    this.append_metrics.forEach((e) => {
      appendMetricsParams[e.value] = '';
    });

    appendMetricsParams[this.tableDimensions.mainColumn] = '';

    return {
      ...this.footer,
      ...appendMetricsParams
    };
  }

  get selectedTableMetrics() {
    const { name } = this.$route;

    switch(name) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-visits':
      case 'app.live-clicks':
        return this.$store.getters.reportParams.columns

      default:
        return this.selectedTableMetricsSimple;
    }
  }

  get selectedTableMetricsSimple() {
    const { type } = this.$route.params;

    const { isHideFilters } = this.$store.state.table;
    let result = this.selectedMetrics;

    if(isHideFilters && this.baseMetrics.report_exclude[type]) { //this.isHideFilters
      const exclude = this.baseMetrics.report_exclude[type];
      result = result.filter((columnName) => !exclude.includes(columnName));
    }

    return result;
  }

  get tableDimensions() {
    const { dimensions } = this.$store.state.reportColumns

    return dimensions[this.type || this.basicType] || {};
  }

  append_metrics: any[] = [];
  selected: any[] = []; //rows
  selected_report: any[] = []; //row
  footer: any = {};

  pLoading: boolean = true;
  
  set loading(value: boolean) {
    // console.trace('loading');
    this.pLoading = value;
  }

  get loading() {
    return this.pLoading;
  }
  
  items: any[] = [];

  //@override
  get enter() {
    return () => {};
    /*
    It is called after the route is fully complete with filters
    */
  }

  //@override
  ready() {/*component itself is rendered*/}

  //@override
  get getReport() {
    return () => {};
  }

  mounted() {
    // Debounce some methods for any case, mostly in order to add some smoothness
    // this.enter = debounce(this.enter.bind(this), 300);
    // this.routeChanged = debounce(this.routeChanged.bind(this), 25);
    // this.getReport = debounce(this.getReport.bind(this), 25);

    const cb = () => {
      this.update();
      this.ready();
    }

    if(!this.isDashbord) {
      //@ts-ignore
      if(this.registerEvents) {
        //@ts-ignore
        this.registerEvents();
      } else {
        this.$nextTick(() => {
          //@ts-ignore
          if(this.registerEvents) {
            //@ts-ignore
            this.registerEvents();
          } else {
            //give up
          }
        });
      }

      if(!this.subReport) {
        this.$filter.promise.then(() => {
          cb();
          this.$filter.clear();
        });
      } else {
        cb();
      }
    }

    if (!this.subReport) {
      this.bus.on('get-report', this.onBusGetReport);
    }
  }

  beforeDestroy() {
    if (!this.subReport) {
      // LEAK: CLEAN MEMORY
      // const { _watchers,  _watcher } = (this as any);
      // _watcher.teardown();
      // _watchers.map((e: any) => e.teardown());

      // WARN: ALLOW SUBSCRIBERS ONLY HERE
      const { _subscribers } = ( this.$store as any );
      while (_subscribers.pop()) {}

      this.bus.off('get-report', this.onBusGetReport);
    }
  }

  onBusGetReport() {
    this.loading = true;
    this.routeChanged();
  }

  update() {
    this.enter();
  }

  get existing_metrics() {
    const { tableDimensions, tableMetrics } = this.$store.state;
    const type = this.$route.params.type;

    if (!tableDimensions[type])
      return [];

    const { mainColumn } = tableDimensions[this.type || type];
    //this.grouping = mainColumn;

    const { additionalColumns } = tableDimensions[type];

    const append = [
      {
        text: this.reportMetricsName(mainColumn),
        value: mainColumn
      }
    ].concat(
      additionalColumns.map((name: any) => {
        return {
          text: this.reportMetricsName(name),
          value: name
        };
      })
    );

    return append.concat(
      tableMetrics.map((name: any) => {
        return {
          text: this.reportMetricsName(name),
          value: name
        };
      })
    );
  }

  get tableOrder(): any[] {
    return this.isReport
      ? this.$store.state.tableOrder[this.$columns.type]
      : this.$store.state.tableOrder[this.$columns.type]
  }

  get headersBeforeFilter(): any[] {
    if(!this.tableOrder) {
      return this.append_metrics.concat(this.existing_metrics);
    }

    const order: any[] = this.tableOrder
      .filter((item) => !this.append_metrics.some((metric) => metric.value === item.value));

    const orderDisabled = order.filter((item) => item.disabled);
    const orderEnabled = order.filter((item) => !item.disabled);

    let result = this.existing_metrics;

    const ordersValues = order.map((item: any) => item.value);
    const filtered = result.filter((item) => !ordersValues.includes(item.value));

    return orderDisabled
      .concat(this.append_metrics)
      .concat(orderEnabled)
      .concat(filtered);
  }

  get headersSimple() {
    let result = this.headersBeforeFilter;

    //@ts-ignore
    const computedColumnsFilter = this.computedColumnsFilter;

    if(computedColumnsFilter) {
      const mainColumn = this.$store.state.tableDimensions[this.type]
        ? this.$store.state.tableDimensions[this.type].mainColumn
        : null;

      result = result.filter((item) => item.value === mainColumn || !computedColumnsFilter.includes(item.value));
    }

    // if(this.$store.state.tableQuery.view === 'tree') {
    //   result = result.filter((item) => !item.export);
    // }

    return result;
  }

  routeChanged() {
    const { commit } = this.$store;

    this.update();

    //Table: reset states
    commit('tableNextReportGroup', null);
    commit('tableSelectedItems', null);

    //TreeView: reset
    this.tree = {};
  }
}
